import $ from 'jquery';

let initialVersion = null;

function checkForNewVersion() {
  $.ajax({
    type: 'GET',
    async: true,
    url: '/manifest.appcache',
    cache: false,
    success: (response) => {
      let checkAgain = false;

      if (initialVersion) {
        if (response === initialVersion) {
          checkAgain = true;
        } else {
          window.location.reload();
        }
      } else {
        checkAgain = true;
        initialVersion = response;
      }

      if (checkAgain) {
        setTimeout(checkForNewVersion, 10 * 60 * 1000);
      }
    },
  });
}

function checkCacheVersion() {
  checkForNewVersion();
}

export default checkCacheVersion;



// WEBPACK FOOTER //
// ./js/utils/check-cache-version.js